import { useEffect, useRef } from "react";

// Poll périodique « poli » : saute les ticks quand l'onglet est masqué
// (document.hidden) et rattrape immédiatement au retour visible. Un onglet
// laissé ouvert en arrière-plan ne génère ainsi AUCUNE requête (discipline
// egress — même famille de risque que l'incident Fair Use de juin 2026).
//
// `intervalMs === null` désactive tout (aucun timer ni listener). L'intervalle
// n'est réarmé que quand sa valeur change — pas à chaque render du caller.
export function useVisiblePoll(onTick: () => void, intervalMs: number | null): void {
  const tickRef = useRef(onTick);
  tickRef.current = onTick;

  useEffect(() => {
    if (intervalMs === null) return;
    const tick = () => {
      if (document.hidden) return;
      tickRef.current();
    };
    const id = setInterval(tick, intervalMs);
    const onVisibility = () => {
      if (!document.hidden) tickRef.current();
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [intervalMs]);
}
